import React from 'react';
import { SelectOption } from 'global';
import { FieldValues, Path, Control } from 'react-hook-form';
import { FACT_NAMES_STRING } from '@trnsact/trnsact-scorecard-sdk';
import { AutocompleteField, ChipsInputField, InputField } from 'components/form';
import { autocompletePropsByType } from '../constants';
import { Stack } from '@mui/material';

interface Props<FormValues extends FieldValues = FieldValues> {
  name: Path<FormValues>;
  control: Control<FormValues>;
  type: FACT_NAMES_STRING;
}

export const StringFieldsByRule = <FormValues extends FieldValues = FieldValues>({
  control,
  name,
  type,
}: Props<FormValues>) => (
  <Stack direction="row" gap="0.5rem" width="100%">
    {autocompletePropsByType?.[type] ? (
      <AutocompleteField<SelectOption, true, FormValues>
        multiple
        size="small"
        control={control}
        name={`${name}.string.value` as Path<FormValues>}
        {...autocompletePropsByType[type]!}
      />
    ) : (
      <ChipsInputField name={`${name}.string.value` as Path<FormValues>} control={control} />
    )}
  </Stack>
);
